export const MAIN = '/main';
export const FILTERS = '/*';
